<template>
    <div class="board__pagination-wrap" v-if="totCnt > 0">
        <a href="javascript:;" class="board__pagination-item prev type02" @click="goPage(1)" v-if="currentNum > 1">맨앞으로</a>
        <a href="javascript:;" class="board__pagination-item prev" @click="goPage(Math.floor((currentNum - 1) / pageCount) * pageCount)" v-if="currentNum > pageCount">이전</a>
        <div class="board__pagination">
            <a href="javascript:;" class="board__pagination-item" :class="currentNum == i ? 'active' : ''" v-for="i in pageList" @click="goPage(i)">{{i}}</a>
        </div>
        <a href="javascript:;" class="board__pagination-item next" @click="goPage(Math.ceil(currentNum / pageCount) * pageCount + 1)" v-if="currentNum < Math.floor((totalPage - 1) / pageCount) * pageCount + 1">다음</a>
        <a href="javascript:;" class="board__pagination-item next type02" @click="goPage(totalPage)" v-if="currentNum != totalPage">마지막으로</a>
    </div>
</template>
<script>
//totCnt, pageRow, pageCount, currentNum을 받아와서 totalPage를 계산
export default {
    props: {
        currentNum: '',
        pageRow: '',
        pageCount: '',
        totCnt: '',
    },
    data() {
        return {
            pageList: '',
        }  
    },
    methods: {
        goPage(pageCount){
            this.$emit("setNum", pageCount);
        }
    },
    computed: {
        //totCnt를 받아와서 totalPage를 계산
        totalPage() {

            let end = Math.ceil(this.currentNum / this.pageCount) * this.pageCount;
            let start = end - (this.pageCount - 1);
            let totalPage = Math.ceil(this.totCnt / this.pageRow);
            if (end > totalPage) {
                end = totalPage
            }
            this.pageList = [];
            for (let i = start; i <= end; i++) {
                this.pageList.push(i);
            }
            
            return totalPage
        }
    },
    mounted() {
    }
}
</script>